import { Paper, styled } from '@mui/material';

export const Container = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: '2rem',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '0.5rem',

  '& svg': {
    fill: theme.palette.grey[900],
  },

  '& svg.delete': {
    fill: theme.palette.red[600],
  },
}));
